/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import { AddJobModel, IAddInvestor, IAddPackage } from "types/customers.type";
import api from "./ApiService";

const getPackages = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/packages?${data}`)
    .then((response: any) => {
      return response;
    });
};

const getInvestors = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/investors?${data}`)
    .then((response: any) => {
      return response;
    });
};

const addPackages = (params: any, formData: FormData) => {
  return api
    .post<IAddPackage>(
      `${process.env.REACT_APP_API_BASE_URL}/packages?${params}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((response: any) => response);
};

const addInvestor = (data?: any) => {
  return api
    .post<IAddInvestor>(process.env.REACT_APP_API_BASE_URL + `/investors`, data)
    .then((response: any) => {
      return response;
    });
};

const updateInvestor = (data?: any) => {
  return api
    .put<IAddInvestor>(process.env.REACT_APP_API_BASE_URL + `/investors`, data)
    .then((response: any) => {
      return response;
    });
};

const getJobs = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/jobs?${data}`)
    .then((response: any) => {
      return response;
    });
};

const addJobs = (params: any, formData: FormData) => {
  return api
    .post<AddJobModel>(
      `${process.env.REACT_APP_API_BASE_URL}/jobs?${params}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((response: any) => response);
};

const createManualDelivery = (data: {
  investorId: number;
  loanNumbers: string[];
}) => {
  return api
    .post(`${process.env.REACT_APP_API_BASE_URL}/manual-delivery`, data)
    .then((response: any) => response);
};

const getPackageMergeTypes = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/package-merge-types?${data}`)
    .then((response: any) => {
      return response;
    });
};

const getPackageContentTypes = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/package-content-types?${data}`)
    .then((response: any) => {
      return response;
    });
};

const getJobLoans = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/jobLoan-loans?${data}`)
    .then((response: any) => {
      return response;
    });
};

const updateJob = (jobID: number, params: any, data?: any) => {
  return api
    .put(
      process.env.REACT_APP_API_BASE_URL +
        `/jobLoan-loans/jobId/${jobID}?${params}`,
      data,
    )
    .then((response: any) => {
      return response;
    });
};

const uploadJob = (jobID: number, params: any, formData: FormData) => {
  return api
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/jobLoan-loans/jobId/${jobID}/files?${params}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((response: any) => {
      return response;
    });
};

const getDocLoans = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/jobDocumentType-loans?${data}`)
    .then((response: any) => {
      return response;
    });
};

const updateDoc = (jobID: number, params: any, data?: any) => {
  return api
    .put(
      process.env.REACT_APP_API_BASE_URL +
        `/jobDocumentType-loans/jobId/${jobID}?${params}`,
      data,
    )
    .then((response: any) => {
      return response;
    });
};

const uploadDoc = (jobID: number, params: any, formData: FormData) => {
  return api
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/jobDocumentType-loans/jobId/${jobID}/files?${params}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((response: any) => {
      return response;
    });
};

const confirmJob = (jobID: any, data: any) => {
  return api
    .post(`${process.env.REACT_APP_API_BASE_URL}/jobs/${jobID}/confirm?${data}`)
    .then((response: any) => {
      return response;
    });
};

const getInvestorPackages = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/packages?${data}`)
    .then((response: any) => {
      return response;
    });
};

const exportInvestorPackages = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/packages/export?${data}`)
    .then((response: any) => {
      return response;
    });
};

const updateInvestorPackages = (data?: any) => {
  return api
    .put(process.env.REACT_APP_API_BASE_URL + `/packages`, data)
    .then((response: any) => {
      return response;
    });
};

const updateInvestorDocPackages = (data?: any) => {
  return api
    .put(process.env.REACT_APP_API_BASE_URL + `/package-document-types`, data)
    .then((response: any) => {
      return response;
    });
};

const addPackageDocTypes = (data?: any) => {
  return api
    .post(process.env.REACT_APP_API_BASE_URL + `/package-document-types`, data)
    .then((response: any) => {
      return response;
    });
};

const getPackageDocTypesByID = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/package-document-types?${data}`)
    .then((response: any) => {
      return response;
    });
};

const uploadPackage = (formData: FormData) => {
  return api
    .post(`${process.env.REACT_APP_API_BASE_URL}/packages/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response: any) => {
      return response;
    });
};

const getPullCriteriaByID = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/PullCriteria?${data}`)
    .then((response: any) => {
      return response;
    });
};

const getInvestorPackagesNew = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/investor-packages?${data}`)
    .then((response: any) => {
      return response;
    });
};

const AdminServices = {
  getPullCriteriaByID,
  getPackages,
  addPackages,
  addInvestor,
  updateInvestor,
  getInvestors,
  getJobs,
  createManualDelivery,
  getPackageMergeTypes,
  addJobs,
  getJobLoans,
  updateJob,
  uploadJob,
  getDocLoans,
  uploadDoc,
  updateDoc,
  confirmJob,
  getInvestorPackages,
  exportInvestorPackages,
  updateInvestorPackages,
  updateInvestorDocPackages,
  uploadPackage,
  getPackageContentTypes,
  getInvestorPackagesNew,
  addPackageDocTypes,
  getPackageDocTypesByID,
};
export default AdminServices;
